import { useState } from 'react';
import { Alert, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { financeService } from '@/services/finance/finance.service';

export type MethodFlow = { id: string; file_name: string; payment_system_id: string | null };
export default function MethodFlows({ methodId, flows, tokens, onChange }: {
  methodId: string; flows: MethodFlow[]; tokens: Array<{ id: string; token: string; direction: string }>;
  onChange: () => Promise<void>;
}) {
  const [tokenId, setTokenId] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const upload = async (files: File[]) => {
    setBusy(true); setError('');
    try {
      for (const file of files) await financeService.uploadMethodFlow(methodId, file, tokenId || undefined);
      await onChange();
    } catch { setError('Не удалось загрузить все файлы. Проверьте список перед повторной загрузкой.'); await onChange(); }
    finally { setBusy(false); }
  };
  return <Paper variant="outlined" sx={{ p: 2 }}><Stack spacing={1.5}>
    <Typography fontWeight={700}>Flow метода · {flows.length}</Typography>
    <Typography variant="body2" color="text.secondary">Несколько файлов для разных способов оплаты. До 20 flow: PNG, JPG, WEBP, PDF, MP4, WEBM или MOV.</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    <TextField select label="Для какого токена" value={tokenId} disabled={busy} onChange={(event) => setTokenId(event.target.value)}>
      <MenuItem value="">Общий flow метода</MenuItem>
      {tokens.map((token) => <MenuItem key={token.id} value={token.id}>{token.direction}: {token.token}</MenuItem>)}
    </TextField>
    {flows.map((flow) => <Stack key={flow.id} direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center">
      <Typography sx={{ flex: 1, overflowWrap: 'anywhere' }}>{flow.file_name} · {tokens.find((token) => token.id === flow.payment_system_id)?.token || (flow.payment_system_id ? 'Токен перемещён' : 'Общий')}</Typography>
      <Button disabled={busy} onClick={async () => { try { await financeService.openMethodFlow(methodId, flow.id); } catch { setError('Не удалось открыть flow'); } }}>Открыть</Button>
      <Button color="error" disabled={busy} onClick={async () => {
        if (!window.confirm(`Удалить flow «${flow.file_name}»?`)) return;
        setBusy(true);
        try { await financeService.deleteMethodFlow(methodId, flow.id); await onChange(); }
        catch { setError('Не удалось удалить flow'); }
        finally { setBusy(false); }
      }}>Удалить</Button>
    </Stack>)}
    <Button component="label" variant="outlined" disabled={busy || flows.length >= 20}>
      {busy ? 'Загрузка…' : 'Добавить flow'}
      <input hidden multiple type="file" accept="image/png,image/jpeg,image/webp,application/pdf,video/mp4,video/webm,video/quicktime,.mov" onChange={(event) => { const files = Array.from(event.target.files || []); event.target.value = ''; if (files.length) void upload(files); }} />
    </Button>
  </Stack></Paper>;
}
